<waitLoading *ngIf="!isLoaded()"></waitLoading>
<sub-header [isModal]="true" [windowHash]="windowHash"></sub-header>
<p-scrollPanel [style]="{width: '100%', height: '80vh'}" styleClass="custombar1 procmap">
    <ng-container *ngIf="isLoaded()">
        <div class="blockContent">
            <div class="proc">
                <div class="start">
                    <div class="badge badge-pill badge-success small mb-0 mt-0 mr-0"><i class="fas fa-play"></i>
                        {{ 'Tasks.procedureMap.start' | translate }} - {{ getStartDescriprion() }}</div>
                </div>
            </div>
        </div>
        <p-overlayPanel #opciones appendTo="body" [style]="{'max-width':'60vw'}">
            <div *ngIf="selectedRule">
                <div *ngFor="let option of selectedRule.processes; let opcNum = index" class="col-12 mb-2">
                    <p-radioButton name="activeProcsOptions" value="{{ opcNum }}" label="{{ option.docDescription }}"
                        [(ngModel)]="selectedRule.activeProcess" (click)="closeOptions(opciones)"></p-radioButton>
                </div>
            </div>
        </p-overlayPanel>
        <p-overlayPanel #divisiones appendTo="body" [style]="{'max-width':'60vw'}">
            <div *ngIf="selectedPhaseDivision">
                <div *ngFor="let phaseDivObj of getPhaseDivisions(selectedPhaseDivision)" class="col-12 mb-2">
                    <button type="button" class="btn btn-outline-secondary btn-sm col-12"
                        (click)="changePhase(phaseDivObj)">{{ phaseDivObj.description }}</button>
                </div>
            </div>
        </p-overlayPanel>
        <p-overlayPanel #phases appendTo="body" [style]="{'max-width':'60vw'}">
            <div *ngIf="selectedPhases">
                <div *ngFor="let phaseObj of selectedPhases" class="col-12 mb-2">
                    <button type="button" class="btn btn-outline-secondary btn-sm col-12"
                        (click)="changePhase(phaseObj)">{{ phaseObj.description }}</button>
                </div>
            </div>
        </p-overlayPanel>
        <ng-container *ngIf="!phase">
            <div *ngFor="let phaseBlock of getPhases()" class="block">
                <div class="blockContent">
                    <div class="proc">
                        <div class="task phase">
                            <div class="taskbox small mb-0 mt-0 mr-2" [ngClass]="taskBoxClasses(phaseBlock)">
                                <i class="task-info fa fa-lg fa-info-circle text-secondary"></i>
                                {{ 'DossierBasicInfo.phase.text' | translate }}: {{ phaseBlock.description }}</div>
                            <div class="badge badge-pill badge-warning phase-change"
                                (click)="changePhase(phaseBlock,divisiones) "><i class="fa fa-step-forward "></i> ver
                                Fase</div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="phase">
            <ng-container *ngFor="let block of blocks">
                <div *ngIf="getMaxTasksInBlock(block).length>0 && getBlockRules(block).length>0" class="block">
                    <div class="blockContent">
                        <div *ngFor="let row of getMaxTasksInBlock(block); let taskNum = index" class="proc">
                            <div *ngFor="let rule of getBlockRules(block)" class="task"
                                [ngClass]="taskClasses(rule,taskNum)">
                                <ng-container *ngIf="(getRuleVisibleTasks(rule).length>taskNum) || taskNum==0">
                                    <p-overlayPanel #info appendTo="body" [dismissable]="true" [showCloseIcon]="true"
                                        [style]="{'max-width':'60vw'}">
                                        <dl>
                                            <dt>Id/Alias</dt>
                                            <dd>{{ rule.ruleId }} / {{ rule.alias }}
                                                {{ getRuleVisibleTasks(rule)[taskNum] ? '['+getRuleVisibleTasks(rule)[taskNum].taskType+']' : ''}}
                                                ({{ 'Tasks.procedureMap.block' | translate}}: {{ rule.block }}) </dd>
                                            <dt>{{ 'Tasks.procedureMap.rule' | translate }}</dt>
                                            <dd>{{ rule.description }}</dd>
                                            <dt>{{ 'Tasks.procedureMap.action' | translate }}</dt>
                                            <dd>{{ getRuleVisibleTasks(rule)[taskNum] ? getRuleVisibleTasks(rule)[taskNum].task : rule.description }}
                                            </dd>
                                            <dt *ngIf="rule.conditionDesc"><i
                                                    class="fa fa-question-circle-o text-warning"></i>
                                                {{ 'Tasks.procedureMap.condition' | translate }}</dt>
                                            <dd *ngIf="rule.conditionDesc">{{ rule.conditionDesc }}</dd>
                                            <dt *ngIf="isDocClassVisible(rule.docClass)">
                                                {{ 'DocumentsSearch.documentClasses' | translate }}</dt>
                                            <dd *ngIf="isDocClassVisible(rule.docClass)">[{{ rule.docClass }}]
                                                {{ rule.docDescription }}</dd>
                                            <dt>{{ 'Tasks.procedureMap.execution.state' | translate }}</dt>
                                            <dd>{{ taskExecutedStr(rule) | translate }}</dd>
                                            <dt *ngIf="getRuleVisibleTasks(rule)[taskNum]">
                                                {{ 'Tasks.destination' | translate }}</dt>
                                            <dd *ngIf="getRuleVisibleTasks(rule)[taskNum]">
                                                {{ getRuleVisibleTasks(rule)[taskNum].mailbox }}</dd>
                                            <dt *ngIf="getRuleVisibleTasks(rule)[taskNum]">
                                                {{ 'Tasks.procedureMap.profile' | translate }}</dt>
                                            <dd *ngIf="getRuleVisibleTasks(rule)[taskNum]">
                                                {{ getProfileDescription(getRuleVisibleTasks(rule)[taskNum].role) }}
                                            </dd>
                                        </dl>
                                    </p-overlayPanel>
                                    <div *ngIf="taskNum==0 && rule.processes.length>1 && rule.executed=='0'"
                                        class="badge badge-pill badge-info small mb-0 mt-0 mr-0 opcional"
                                        (click)="openOptions($event,rule,opciones)"><i class="fa fa-question"></i>
                                        {{ 'Tasks.procedureMap.optional' | translate }}</div>
                                    <div class="taskbox small mb-0 mt-0 mr-2" [ngClass]="taskBoxClasses(rule)">
                                        <i class="task-info fa fa-lg fa-info-circle text-secondary"
                                            (click)="info.toggle($event)"
                                            pTooltip="{{ 'Tasks.procedureMap.viewDetails' | translate }}"
                                            tooltipPosition="top" showDelay="1000"></i> {{ getTaskName(rule,getRuleVisibleTasks(rule)[taskNum])
                                        }}
                                    </div>
                                    <div *ngIf="isPhaseChange(rule) && !isMultiplePhaseChange(rule) && showPhaseChangeButton(rule)"
                                        class="badge badge-pill badge-warning phase-change"
                                        (click)="changePhase(rule,divisiones) "><i class="fa fa-step-forward "></i> ver
                                        Fase</div>
                                    <div *ngIf="isPhaseChange(rule) && isMultiplePhaseChange(rule) && showPhaseChangeButton(rule)"
                                        class="badge badge-pill badge-warning phase-change"
                                        (click)="changePhase(rule,phases) "><i class="fa fa-step-forward "></i> ver
                                        Fase</div>
                                </ng-container>
                                <ng-container *ngIf="getRuleVisibleTasks(rule).length<=taskNum && taskNum>0">
                                    <div class="empty-taskbox alert small mb-0 mt-0 mr-0">&nbsp;</div>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </ng-container>
    </ng-container>
</p-scrollPanel>